window.addEventListener("load", function () {
    $("body").click(function () {
        if ($(".country_switch").hasClass("open")) {
            $(".country_switch").removeClass("open");
        }
    });

    $(".country_switch").click(function (e) {
        e.stopPropagation();
    });

    $(".country_switch_select").click(function (e) {
        e.stopPropagation();
        let parent = $(this).parent();
        if (parent.hasClass("open")) {
            parent.removeClass("open");
        } else {
            $(".country_switch").removeClass("open"); // 关闭其他已展开的菜单
            parent.addClass("open");
        }
    });
});
